import React, { useCallback } from "react";
import { FormattingToolbar } from "./FormattingToolbar/FormattingToolbar";
export const EditorStaticToolbarPluginView = ({ view, commands, mode, disableTooltips = false, items, showDividers, showArrows, }) => {
    const { state } = view;
    const handleCommand = useCallback((command) => {
        command.run(view.state, view.dispatch.bind(view), view);
    }, [view]);
    return (React.createElement(FormattingToolbar, { state: state, showDividers: showDividers, showArrows: showArrows, items: items, commands: commands, mode: mode, disableTooltips: disableTooltips, onCommand: handleCommand }));
};
